<template>
    <van-popup v-model:show="show" :style="{
        minWidth: '100%',
        minHeight: '60%',
        background: 'transparent',
        borderRadius: '10px',
        color: '#95a9d3',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column'
    }">
        <div class="pop_container">
            <div class="close_icon">
                <img src="@/assets/close_bai.png" alt="" @click="close">
            </div>
            <div class="bell_icon">
                <img src="@/assets/offers/deposit_promotions_iconmsg.png" alt="">
            </div>
            <div class="content">
                {{ $t('offers.promotionContent') }}
                <span>{{ $t(title) }}</span>
            </div>
            <div class="btn_container">
                <MainButton :title="$t('common.ok')" :onclick="close" :activeStatus="true" />
            </div>
        </div>
    </van-popup>
</template>

<script setup lang="ts">
import MainButton from '../../components/common/mainButton.vue'
import { ref } from 'vue'

const show = ref(false)
const title = ref('')
const open = (data: string) => {
    title.value = `offers.${data}`
    show.value = true
}
const close = () => {
    show.value = false
}
defineExpose({
    open,
})

</script>
<style scoped>
.pop_container {
    background: rgb(0, 86, 86);
    border: 1px solid rgb(13, 176, 174);
    padding: 15px;
    border-radius: 20px;
    height: 300px;
    width: 230px;
}

.content {
    padding: 5px 15px;
    font-size: 14px;
    color: rgb(255,255,255,0.4);
    line-height: 24px;
}

.content span {
    color: rgb(245, 200, 76);
}

.van-overlay {
    background-color: #00000047
}

.close_icon {
    display: flex;
    justify-content: right;
}

.close_icon img {
    width: 25px;
    opacity: 0.5;
}

.bell_icon {
    display: flex;
    justify-content: center;
}

.bell_icon img {
    width: 55px;
    padding: 25px 0;
}

.btn_container {
    padding: 15px 35px;
}

.van-overlay {
    background-color: #000000bd;
}
</style>